export var PRESENCE_APP_DEF_ID = '401c08e7-b43e-4323-99f9-1f9f8138ff88';
export var INIT_BATCH_TIME = 1000 * 2; // 2 sec
export var KEEP_ALIVE_TIME = 1000 * 60 * 4; // 4 min
export var WATCH_GROUP_TIME = 1000 * 60 * 10; // 10 min
export var PRESENCE_URL = '/_api/presence-service';
export var PRESENCE_SERVER_URL = '/_api/chat-presence-server';
//# sourceMappingURL=constants.js.map